import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './helpers/auth.guard';
import { EventDetailPage } from './pages/events/event-detail/event-detail.page';

const routes: Routes = [
  {
    path: 'b/:type',
    loadChildren: () =>
    import('./pages/welcome/welcome.page.module').then(
      (m) => m.WelcomePageModule
    ),
  },
  {
    path: 'sso/:type/:value',
    loadChildren: () =>
      import('./pages/sso/sso.module').then((m) => m.SSOPageModule),
  },
  {
    path: 'welcome',
    loadChildren: () =>
      import('./pages/welcome/welcome.page.module').then(
        (m) => m.WelcomePageModule
      ),
  },
  // {
  //   path: 'onboarding-notifications',
  //   loadChildren: () =>
  //     import('./pages/onboarding-notifications/onboarding-notifications.page.module').then(
  //       (m) => m.OnboardingNotificationsPageModule
  //     ),
  // },
  // {
  //   path: 'setup-notifications',
  //   loadChildren: () =>
  //     import('./pages/setup-notifications/setup-notifications.page.module').then(
  //       (m) => m.SetupNotificationsPageModule
  //     ),
  // },
  {
    path: 'create-gmb',
    loadChildren: () =>
      import('./pages/create-gmb/create-gmb.module').then((m) => m.CreateGmbModule),
  },
  // {
  //   path: 'login',
  //   loadChildren: () =>
  //     import('./pages/login/login.page.module').then((m) => m.LoginPageModule),
  // },
  {
    path: 'tabs',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/tabs/tabs.module').then((m) => m.TabsPageModule),
  },
  {
    path: 'tasks',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/tasks/tasks.module').then((m) => m.TasksPageModule),
  },
  {
    path: 'leads',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/leads/leads.module').then(
            (m) => m.LeadsPageModule
          ),
      },
    ],
  },
  {
    path: 'messages',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/messages/messages.module').then(
            (m) => m.MessagesPageModule
          ),
      },
    ],
  },
  {
    path: 'support',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/support/support.module').then((m) => m.SupportModule),
  },
  {
    path: 'account',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/account/account.module').then((m) => m.AccountPageModule),
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/settings/settings.module').then((m) => m.SettingsPageModule),
  },
  {
    path: 'store',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/store/store.module').then((m) => m.StorePageModule),
  },
  {
    path: 'nfc',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/nfc/nfc.module').then((m) => m.NFCPageModule),
  },
  // {
  //   path: 'tabs/contacts',
  //   canActivate: [AuthGuard],
  //   children: [
  //     {
  //       path: 'detail/:id',
  //       component: ContactDetailPage,
  //     },
  //     {
  //       path: 'import',
  //       component: ContactImportPage,
  //     },
  //   ],
  // },
  {
    path: 'tabs/events/detail/:id',
    component: EventDetailPage,
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./pages/onboarding/onboarding.module').then(
        (m) => m.OnboardingPageModule
      ),
  },
  {
    path: 'payment',
    //canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        //only: [BoxxStorePermissionsProps.boxxStoreModule],
      },
    },
    loadChildren: () =>
      import('./pages/payment/payment.module').then((m) => m.PaymentPageModule),
      
  },
  // {
  //   path: 'tasks',
  //   //canActivate: [AuthGuard, NgxPermissionsGuard],
  //   data: {
  //     permissions: {
  //       //only: [BoxxStorePermissionsProps.boxxStoreModule],
  //     },
  //   },
  //   loadChildren: () =>
  //     import('./pages/tasks/tasks.module').then((m) => m.TasksPageModule),
  // },
  // {
  //   path: '',
  //   redirectTo: '/onboarding/register',
  //   pathMatch: 'full',
  // },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
